import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { FeedbackWidget } from './FeedbackWidget';

interface FeedbackWidgetWithCaptchaProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * FeedbackWidget wrapped with Google reCAPTCHA v3 provider
 * This provides bot protection for the feedback submission form
 */
export const FeedbackWidgetWithCaptcha: React.FC<FeedbackWidgetWithCaptchaProps> = ({ isOpen, onClose }) => {
  // Get the reCAPTCHA site key from environment variables
  const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
  
  if (!recaptchaSiteKey) {
    console.warn('[FeedbackWidget] reCAPTCHA site key not configured. Bot protection disabled.');
    // In development without key, show the widget without protection
    return <FeedbackWidget isOpen={isOpen} onClose={onClose} />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body'
      }}
    >
      <FeedbackWidget isOpen={isOpen} onClose={onClose} />
    </GoogleReCaptchaProvider>
  );
};

export default FeedbackWidgetWithCaptcha;
